import { BOARD_NO_LONGER_AVAILABLE } from "../constants";
import { ADOBE_BOARD_ERROR_EVENT_KEY } from "../../../../../../services/analytics/constants";

export const boardNotFound = state => ({
  ...state,
  trackPage: {
    ...state.trackPage,
    error: BOARD_NO_LONGER_AVAILABLE,
    events: [ADOBE_BOARD_ERROR_EVENT_KEY]
  }
});
